module.exports = {"title":"Comics","layout":"page","path":"/comics","body":"<h3><a href=\"http://imgur.com/a/nnIS9\">長いため息のように (like a long sigh)</a> (2009)</h3>\n<a href=\"http://imgur.com/a/nnIS9\">\n\t<img src=\"http://i.imgur.com/DkSOoky.jpg\" width=\"300\">\n</a>\n<h3><a href=\"http://imgur.com/a/zgBZU\">CERT</a> (2008)</h3>\n<a href=\"http://imgur.com/a/zgBZU\">\n\t<img src=\"http://i.imgur.com/2dL6VnR.jpg\" width=300>\n</a>\n<h3><a href=\"http://imgur.com/a/NjEZA\">fly away home</a> (2007)</h3>\n<a href=\"http://imgur.com/a/NjEZA\">\n\t<img src=\"fah.png\" width=300>\n</a>\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/comics/index.md
// module id = 514
// module chunks = 0